import {
    BetBuilderBetslipNotification,
    ExtendedBetslipNotification,
    IBetslipNotification,
    OveraskBetslipNotification,
    SimpleBetslipNotification,
} from '../../validation/errors/betslip-notification';
import { BetslipNotificationMessageType, IBetslipNotificationState } from '../state';

export class BetslipNotificationConverter {
    static fromState(state: IBetslipNotificationState): IBetslipNotification | null {
        switch (state.messageType) {
            case BetslipNotificationMessageType.Simple:
                return new SimpleBetslipNotification(state.message);
            case BetslipNotificationMessageType.Extended:
                return new ExtendedBetslipNotification(state.title, state.message);
            case BetslipNotificationMessageType.BetBuilder:
                return new BetBuilderBetslipNotification(state.message);
            default:
                return null;
        }
    }

    static toState(notification: IBetslipNotification): IBetslipNotificationState {
        if (notification instanceof BetBuilderBetslipNotification) {
            return {
                messageType: BetslipNotificationMessageType.BetBuilder,
                title: '',
                message: notification.message,
            };
        }
        if (notification instanceof SimpleBetslipNotification) {
            return {
                messageType: BetslipNotificationMessageType.Simple,
                title: '',
                message: notification.message,
            };
        }

        if (notification instanceof ExtendedBetslipNotification) {
            return {
                messageType: BetslipNotificationMessageType.Extended,
                title: notification.title,
                message: notification.message,
            };
        }

        if (notification instanceof OveraskBetslipNotification) {
            return {
                messageType: BetslipNotificationMessageType.Overask,
                title: notification.title || '',
                message: notification.message,
            };
        }

        return {
            messageType: BetslipNotificationMessageType.NotSet,
            title: '',
            message: '',
        };
    }
}
